export default function IsMultiTerm(data) {
  let initial = data.quoteResults[0].isDecreasingTerm;

  if (initial === null) {
      initial = false;
  }

  let ismts = false;

  for (let idx = 0; idx < data.quoteResults.length; idx++) {
     let ts = data.quoteResults[idx].isDecreasingTerm

     if (ts === null) {
         ts = false;
     }

     if (!ismts && (initial !== ts)) {
        ismts = true;
        break;
     }
  }

  return ismts;
};
